// Services Page JavaScript

document.addEventListener('DOMContentLoaded', function() {
    // Initialize animations
    initializeAnimations();
    
    // Add scroll animations
    setupScrollAnimations();

    const loadMoreBtn = document.getElementById('loadMoreBtn');
    const form = document.getElementById('serviceForm');
    const header = document.querySelector('header');
    if (!loadMoreBtn || !form || !header) return;
});

// Function to redirect to booking page
function redirectToBooking() {
    window.location.href = '/booking.html';
}

// Initialize page animations
function initializeAnimations() {
    // Add fade-in class to hero elements
    const heroTitle = document.querySelector('.hero-title');
    const heroSubtitle = document.querySelector('.hero-subtitle');
    
    if (heroTitle) heroTitle.classList.add('fade-in');
    if (heroSubtitle) {
        setTimeout(() => {
            heroSubtitle.classList.add('fade-in');
        }, 300);
    }
}

// Setup scroll-triggered animations
function setupScrollAnimations() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const element = entry.target;
                
                // Add appropriate animation class based on element type
                if (element.classList.contains('service-content')) {
                    element.classList.add('slide-in-left');
                } else if (element.classList.contains('service-image')) {
                    element.classList.add('slide-in-right');
                } else {
                    element.classList.add('fade-in');
                }
                
                // Stop observing this element
                observer.unobserve(element);
            }
        });
    }, observerOptions);

    // Observe service sections
    const serviceContents = document.querySelectorAll('.service-content');
    const serviceImages = document.querySelectorAll('.service-image');
    const sectionHeaders = document.querySelectorAll('.section-header');

    serviceContents.forEach(content => observer.observe(content));
    serviceImages.forEach(image => observer.observe(image));
    sectionHeaders.forEach(header => observer.observe(header));
}

// Add hover effects to service images
document.addEventListener('DOMContentLoaded', function() {
    const serviceImages = document.querySelectorAll('.image-placeholder');
    
    serviceImages.forEach(image => {
        image.addEventListener('mouseenter', function() {
            this.style.transform = 'scale(1.05)';
            this.style.transition = 'transform 0.3s ease';
        });
        
        image.addEventListener('mouseleave', function() {
            this.style.transform = 'scale(1)';
        });
    });
});

// Loading state for discover more button
function showLoadingState(button) {
    const originalText = button.textContent;
    button.textContent = 'Loading...';
    button.disabled = true;
    
    setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
    }, 1000);
}

// Add click event to discover more button with loading state
document.addEventListener('DOMContentLoaded', function() {
    const discoverBtn = document.querySelector('.btn-discover');
    
    if (discoverBtn) {
        discoverBtn.addEventListener('click', function(e) {
            showLoadingState(this);
            
            setTimeout(() => {
                redirectToBooking();
            }, 500);
        });
    }
});

// Parallax effect for hero section (optional enhancement)
window.addEventListener('scroll', function() {
    const scrolled = window.pageYOffset;
    const heroSection = document.querySelector('.hero-section');
    
    if (heroSection) {
        const rate = scrolled * -0.5;
        heroSection.style.transform = `translate3d(0, ${rate}px, 0)`;
    }
});

// Service section counter animation (optional enhancement)
function animateCounters() {
    const counters = document.querySelectorAll('[data-count]');
    
    counters.forEach(counter => {
        const target = parseInt(counter.getAttribute('data-count'));
        const increment = target / 100;
        let current = 0;
        
        const timer = setInterval(() => {
            current += increment;
            counter.textContent = Math.floor(current);
            
            if (current >= target) {
                counter.textContent = target;
                clearInterval(timer);
            }
        }, 20);
    });
}

// Error handling for external dependencies
window.addEventListener('error', function(e) {
    console.warn('Services page error:', e.message);
    // Graceful degradation - ensure basic functionality works
});

// Accessibility improvements
document.addEventListener('DOMContentLoaded', function() {
    // Add keyboard navigation support
    const interactiveElements = document.querySelectorAll('.btn-discover, .feature-item');
    
    interactiveElements.forEach(element => {
        element.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    });
});

// Export functions for potential external use
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        redirectToBooking
    };
}